// extracted by mini-css-extract-plugin
export var aboveInput = "_nc-0";
export var actionButton = "_nc-5";
export var actionButtonContainer = "_nc-1";
export var actionIcon = "_nc-6";
export var aiInfoContainer = "_nc-2";
export var attachmentWrapper = "_nc-7";
export var bold = "_nc-3";
export var checkIcon = "_nc-8";
export var clickingRecipientBar = "_nc-11";
export var commentThreadSwitch = "_nc-a";
export var draftImage = "_nc-b";
export var draftImageContainer = "_nc-c";
export var draftImages = "_nc-e";
export var editButton = "_nc-g";
export var editor = "_nc-f";
export var editorContainer = "_nc-y";
export var editorErrorTooltipWrapper = "_nc-9";
export var headerDivider = "_nc-h";
export var icon = "_nc-i";
export var info = "_nc-j";
export var internal = "_nc-n";
export var internalDivider = "_nc-k";
export var internalMessage = "_nc-l";
export var messageInputCard = "_nc-m";
export var messageInputForm = "_nc-o";
export var messageInputFormInternal = "_nc-p";
export var options = "_nc-q";
export var publicMessageCustomer = "_nc-s";
export var publicMessageMerchant = "_nc-r";
export var removeImageButton = "_nc-d";
export var replyButtons = "_nc-t";
export var showSignatureButton = "_nc-u";
export var spinner = "_nc-v";
export var verticalButtonDivider = "_nc-4";
export var visibilitySelector = "_nc-w";
export var warning = "_nc-x";
export var wrappingText = "_nc-z";
export var writingInternalNoteTopBorder = "_nc-10";